import type { ReactNode } from 'react';

import { cx } from './cx';

/**
 * One muted sentence in the middle of a card with nothing in it.
 *
 * A card that renders empty rather than disappearing is a card whose absence of rows means
 * something — "nothing to ring back" is information. The cards whose emptiness means
 * nothing do not render at all, and that difference is decided by the caller, not here.
 */
export function EmptyState({ className, children }: { className?: string; children?: ReactNode }) {
  return (
    <p className={cx('text-secondary text-ink-3 text-center px-4 py-6 m-0', className)}>
      {children}
    </p>
  );
}
